import React from "react";
import { Box, Typography, List, ListItem, ListItemText } from "@mui/material";

export default function ActivityLog({ selectedEquipment }) {
  const dummyLogs = selectedEquipment
    ? [
        "2023-01-01: Calibration completed by John Doe.",
        "2022-12-15: Calibration failed by Jane Smith.",
      ]
    : [];

  return (
    <Box>
      <Typography variant="subtitle1" fontWeight="bold" mb={1}>
        Timeline / Activity Log
      </Typography>
      {selectedEquipment ? (
        <List>
          {dummyLogs.map((log, index) => (
            <ListItem key={index}>
              <ListItemText primary={log} />
            </ListItem>
          ))}
        </List>
      ) : (
        <Typography variant="body2" color="text.secondary">
          Please select an equipment to view its activity log.
        </Typography>
      )}
    </Box>
  );
}
